import request from '../utils/request'

/**
 * 仪表盘统计相关API
 */

// 获取平台整体概览统计数据
export function getOverviewStats() {
  return request({
    url: '/overview/overall',
    method: 'get'
  })
}

// 获取当前用户的概览统计数据
export function getUserOverviewStats() {
  return request({
    url: '/overview/user',
    method: 'get'
  })
}

// 使概览缓存失效
export function invalidateOverviewCache() {
  return request({
    url: '/overview/invalidate-cache',
    method: 'post'
  })
}

// 获取指定机器人的详细统计数据
export function getRobotStats(robotId) {
  return request({
    url: `/stats/robot/${robotId}`,
    method: 'get'
  })
}

// 获取机器人统计数据趋势
export function getRobotStatsTrend(robotId, days = 7) {
  return request({
    url: `/stats/robot/trend/${robotId}`,
    method: 'get',
    params: { days }
  })
}

// 获取指定项目的详细统计数据
export function getProjectStats(projectId) {
  return request({
    url: `/stats/project/${projectId}`,
    method: 'get'
  })
}

// 获取项目统计数据趋势
export function getProjectStatsTrend(projectId, days = 30) {
  return request({
    url: `/stats/project/trend/${projectId}`,
    method: 'get',
    params: { days }
  })
}

// 获取当前用户的详细统计数据
export function getUserStats() {
  return request({
    url: '/stats/user',
    method: 'get'
  })
}

// 获取数据看板统计
export function getDataBoardStats() {
  return request({
    url: '/overview/stats',
    method: 'get'
  })
}

// 获取任务完成趋势
export function getTaskTrend(days = 7) {
  return request({
    url: '/overview/task-trend',
    method: 'get',
    params: { days }
  })
}

// 获取机器人活跃度排行
export function getRobotActivity() {
  return request({
    url: '/overview/robot-activity',
    method: 'get'
  })
}

export default {
  getOverviewStats,
  getUserOverviewStats,
  invalidateOverviewCache,
  getRobotStats,
  getRobotStatsTrend,
  getProjectStats,
  getProjectStatsTrend,
  getUserStats,
  getDataBoardStats,
  getTaskTrend,
  getRobotActivity
}
